import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiShield } = FiIcons;

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (sectionId) => {
    if (location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  return (
    <header className="bg-slate-900 text-white py-4 px-6 shadow-lg border-b border-white/5 no-print sticky top-0 z-50">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        {/* 2-Line Logo Lockup */}
        <div 
          className="flex items-center gap-3 cursor-pointer group"
          onClick={() => {
            if (location.pathname === '/') {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            } else {
              navigate('/');
            }
          }}
        >
          <SafeIcon 
            icon={FiShield} 
            className="text-blue-500 text-[24px] md:text-[28px] group-hover:scale-110 transition-transform" 
          />
          
          <div className="flex flex-col leading-[1.1] font-sora justify-center">
            <span className="text-[18px] md:text-[22px] font-[800] text-white tracking-tight">
              ProtegeTuRed
            </span>
            <span className="text-[9.5px] md:text-[10.5px] font-[600] text-slate-400">
              by ComplianceBOX
            </span>
          </div>
        </div>

        <nav className="hidden lg:block">
          <ul className="flex gap-8 text-sm font-medium text-slate-300">
            <li>
              <button onClick={() => scrollToSection('como-funciona')} className="hover:text-blue-400 transition-colors">
                Cómo funciona
              </button>
            </li>
            <li>
              <button onClick={() => scrollToSection('que-evalua')} className="hover:text-blue-400 transition-colors">
                Qué evalúa
              </button>
            </li>
            <li>
              <button onClick={() => scrollToSection('tu-reporte')} className="hover:text-blue-400 transition-colors">
                Tu reporte
              </button>
            </li>
          </ul>
        </nav>

        <button 
          onClick={() => navigate('/assessment')}
          className="px-5 py-2.5 bg-blue-600 hover:bg-blue-500 text-white rounded-xl text-sm font-bold transition-all shadow-lg shadow-blue-500/20 active:scale-95"
        >
          Iniciar Evaluación
        </button>
      </div>
    </header>
  );
}